module.exports = __webpack_public_path__ + "static/img/relief01.ee4db46.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/relief01.bmp
// module id = C/aj
// module chunks = 2